"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = uriToUrl;
/**
 * Function that ensures a complete and proper url with protocol and host.
 *
 * @example
 * const uri = uriToUrl('foo.m3u8', window.location);
 * console.log(uri); // 'https://www.hudl.com/foo.m3u8'
 *
 * @param {string} source url for the video
 * @param ({protocol: string, host: string}) generally window.location
 * @return {string} complete and prop url
 */
function uriToUrl(src, location) {
  if (src && src.indexOf('://') === -1) {
    return "".concat(location.protocol, "//").concat(location.host).concat(src);
  }
  return src;
}